<template>
  <div class="invite_loading">
    <img src="./img/loading.gif" alt />
  </div>
</template>

<script>
export default {
  name: 'loading',
};
</script>

<style lang="stylus" scoped>
px = (1 / 3.75vw);

.invite_loading {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.4);
  z-index: 999999;
  img {
    width: 15%;
    margin-left: px * 165;
    margin-top: px * 300;
    border-radius: 25%;
  }
}
</style>
